import * as actionCreators from 'client/redux/confirmUser/actionCreators';
import { CONFIRM_USER } from 'client/redux/confirmUser/constants';

export const confirmUser = form => dispatch => {
  return dispatch(actionCreators.confirmUser(CONFIRM_USER, form));
};
